import { Link } from "react-router-dom";
import SEO from "@/components/SEO";

export default function NotFound() {
  return (
    <>
      <SEO title="Page Not Found | Veterans for Indiana" description="The page you're looking for couldn't be found." path="/" />
      <section className="bg-cream py-28">
        <div className="container-x text-center">
          <p className="eyebrow">404</p>
          <h1 className="h-display text-5xl sm:text-6xl text-navy mt-2">Page Not Found</h1>
          <span className="divider-green mt-4 inline-block" />
          <p className="mt-6 text-navy-deep/80">The page you&apos;re looking for has moved or doesn&apos;t exist.</p>
          <div className="mt-8">
            <Link to="/" className="btn btn-primary" data-testid="notfound-home-cta">Back to Home</Link>
          </div>
        </div>
      </section>
    </>
  );
}
